<template>
  <div class="base-info error-deal" v-show="drawerLevel == 1 ? isSpread : drawerLevel == 2 ? isSubSpread : true">
    <!--基础信息-->
    <div class="change" v-if="!option.isAdd && option.btnPosition === 'top'">
      <el-button v-if="option.edit && !option.isEdit" :disabled="option.disabled" :class="['t-r-btn', { 'btn-disabled': option.disabled }]" @click="change" size="mini">{{option.editType || $t('button.edit')}}
      </el-button>
      <slot name="buttonBefore"></slot>
      <div v-if="option.isEdit">
        <el-button class="t-r-btn" @click="save" :loading="isSubmitting" size="mini">{{$t('button.save')}}</el-button>
        <el-button class="t-r-btn" @click="cancelChange" size="mini">{{$t('button.cancel')}}</el-button>
      </div>
      <slot name="button"></slot>
    </div>
    <div class="content-box">
      <div class="left-box" v-show="option.showLogo">
        <slot name="left"></slot>
      </div>
      <div class="center-box" :style="option.styleObject" :class="[{ 'show-all': option.showAll || option.isAdd }, { sixLine: line == 6 }]" ref="centerBox">
        <!-- 编辑区 -->
        <el-row class="content" v-if="option.isEdit" :gutter="24">
          <el-form ref="baseInfo" :rules="option.rules" :model="data" :label-width="getLabelWidth" :label-position="option.labelPosition">
            <el-col v-if="!item.hidden" class="custom-style" :class="{ 'value-position-left': item.valuePosition === 'left', 'height-initial': item.heightInitial }" v-for="(item, index) in option.field" :span="item.span ? item.span : 24" :offset="item.offset" :pull="item.pull" :key="option.refreshKey ? item[option.refreshKey] : `edit${index}`" :style="{ ...item.colStyle, clear: item.clear ? item.clear : 'none' }">
              <div class="line" v-if="item.type === 'line'"></div>
              <div :style="{ height: item.height + 'px' }" v-else-if="item.type === 'fill'"></div>
              <template v-else-if="item.type === 'prompt'">
                <div v-html="item.content" :style="item.style"></div>
              </template>
              <template v-else-if="item.type === 'group'">
                <div v-for="(subItem, index) in item.children" :key="index">
                  <label class="u-label" :style="{ width: item.labelWidth || getLabelWidth }">
                    {{ $t(subItem.placeholder) }}
                  </label>
                  <span class="u-val" :style="{ 'max-width': getValWidth }" v-if="subItem.type === 'date'">
                    {{ data[subItem.name] | filterTimeToFormatTime }}
                  </span>
                  <span class="u-val" :style="{ 'max-width': getValWidth }" v-else-if="subItem.type === 'todo'"> TODO </span>
                  <span class="u-val" :style="{ 'max-width': getValWidth }" v-else>
                    {{ data[subItem.name] }}
                  </span>
                </div>
              </template>
              <template v-else-if="item.type === 'contact_info'">
                <contact-info :single="item.single" :name="item.name" :model="data" :label="$t(item.placeholder)" v-model="data[item.name]" :rule="item['rule']" :required="item.required || false"></contact-info>
              </template>
              <template v-else-if="item.type === 'print_size'">
                <slot name="printSize"></slot>
              </template>
              <template v-else-if="item.type === 'addresses'">
                <addresses :single="item.single" :name="item.name" :model="data" v-model="data[item.name]" :rule="item['rule']" :required="item.required || false"></addresses>
              </template>
              <template v-else-if="item.type === 'checkSelect'">
                <check-select :model="data" :checkText="item.checkText" :itemFar="item" :name="item.name" :selectList="item.selectList" :disabled="item.disabled" :className="item.className" :showList="item.showList" @changeShow="changeShow" :subType="item.subType">
                  <template v-if="item.slot"><span v-html="item.slot"></span></template>
                </check-select>
              </template>
              <template v-else-if="item.type === 'user_defined'">
                <div v-html="data[item.name]" :style="item.styleObject"></div>
              </template>
              <template v-else-if="item.type === 'user_defined_link'">
                <div style="margin-top: -12px">
                  <span :style="item.styleObject">{{ item.linkData.prompt }}</span><router-link :target="item.linkData.target" :to="item.linkData.to" :class="'clickable'">{{ item.linkData.text }}</router-link><span>{{ item.linkData.prompt_end }}</span>
                </div>
              </template>
              <el-form-item :rules="item.rules" :class="{
                  selectMultiple: item.type === 'selectMultiple',
                  heightAuto: needHheightAuto.includes(item.type),
                  contact_info: item.type === 'contact_info',
                  noWidth: item.type === 'noInput',
                  contentReadonly: item.contentReadonly,
                  err: item.isErr,
                  [item.className ? item.className : '']: item.className
                }" :label="$t(item.placeholder)" :prop="item.name" :label-width="item.labelWidth || getLabelWidth" v-else>
                <template slot="label" v-if="item.labelTitle">
                  {{$t(item.placeholder)}}
                  <i class="icon pointer el-icon-warning-outline" :title="$t(item.labelTitle)"></i>
                </template>
                <el-input v-if="item.type === 'text' || item.type === 'link'" size="mini" :type="item.inputType || 'text'" :disabled="item.disabled || false" v-model="data[item.name]" :placeholder="$t(item.mark) || $t(item.placeholder)" :show-password="item.showPassword || false" :autocomplete="item.autocomplete || 'off'" :maxlength="item.maxlength" @change="(ev) => (item.change ? item.change(ev) : () => {})" @input="(ev) => (item.input ? item.input(ev) : () => {})" @blur="(e) => textInputBlur({ e, item, value: data[item.name], data })">
                  <template v-if="item.suffix && item.suffix.tag === 'span'">
                    <span slot="suffix" :class="item.suffix.class">{{ item.suffix.content }}</span>
                  </template>
                </el-input>
                <el-cascader size="mini" v-else-if="item.type === 'cascader'" v-model="data[item.name]" ref="cascader" :options="item.option" :props="item.props || {}" :collapse-tags="item.collapseTags" :filterable="item.filterable" :popper-class="item.popperClass" :show-all-levels="item.showAllLevels" @change="(ev) => handleSelectChange(ev, item)"></el-cascader>
                <div v-else-if="item.type === 'select'" class="baseinfo-select">
                  <el-select size="mini" v-model="data[item.name]" style="width: 100%" :filterable="item.filterable" :remote="item.remote || false" @visible-change="(ev) => handleVisibleChange(ev, item)" @change="(ev) => handleSelectChange(ev, item, data)" @focus="(ev) => handleSelectFocus(ev, item)" @blur="(ev) => handleSelectBlur(ev, item)" :remote-method="item.remoteMethod" :loading="item.loading || false" :disabled="item.disabled" :clearable="item.clearable" :multiple="item.multiple || false" :collapse-tags="item.collapse || false" :reserve-keyword="item.reserveKeyword || false" :default-first-option="item.defaultFirst || false" :placeholder="item.notice || $t('tip.select')" :id="item.id" :ref="`${item.name}`" :allow-create="item.allowCreate || false" :value-key="item.valueKey" :popper-class="item.popperClass">
                    <div v-if="item.multiple && item.checkAll && item.option.length > 1" class="check-all-wrapper">
                      <el-checkbox v-model="item.checked" @change="(ev) => handleCheckAllChange(ev, item)">{{$t('portal.quan-xuan')}}</el-checkbox>
                    </div>
                    <el-option v-for="(subItem, index) in item.option" :key="index" :disabled="subItem.disabled" :label="subItem[item.label] || $t(subItem.name)" :value="item.valueKey ? subItem : subItem.id" :title="subItem.other ? subItem.other : $t(subItem.name)">
                      <template v-if="subItem.em">
                        <span v-html="subItem.em"></span>
                      </template>
                      <template v-else>
                        {{ item.label ? subItem[item.label] : subItem.other ? subItem.other : $t(subItem.name) }}
                      </template>
                    </el-option>
                  </el-select>
                  <span v-if="item.link" class="select-link" @click="selectLinkClick(data[item.name], item.option)" :title="$t('portal.dian-ji-cha-kan')">
                    {{ data[item.name] | filterData(item) }}
                  </span>
                </div>
                <span class="u-val pointer" v-else-if="item.type === 'button'" style="color: #2469c6" @click="addSlug">{{$t('portal.slug-url-lian-jie')}}</span>
                <span class="u-val pointer" v-else-if="item.type === 'url'" style="color: #2469c6; width: 100%" @click="addSlug('edit')">
                  {{ data[item.name] }}
                </span>
                <el-select size="mini" v-else-if="item.type === 'selectMultiple'" v-model="data[item.name]" style="width: 100%" multiple filterable collapse-tags :multiple-limit="typeof item.multipleLimit === 'number' ? item.multipleLimit : 0" @visible-change="(v) => visibleChange(v, item.name)" @change="(ev) => handleSelectChange(ev, item)">
                  <div v-if="item.checkAll && item.option.length > 1" class="check-all-wrapper">
                    <el-checkbox v-model="item.checked" @change="(ev) => handleCheckAllChange(ev, item)">{{$t('portal.quan-xuan')}}</el-checkbox>
                  </div>
                  <el-option v-for="subItem in item.option" :key="subItem.id" :label="$t(subItem.name)" :value="subItem.id"> </el-option>
                </el-select>
                <template v-else-if="item.type === 'autocompleteAndSelect'">
                  <el-autocomplete size="mini" style="max-width: calc(44% - 2px); float: left" v-model="data[item.name]" :fetch-suggestions="(queryString, cb) => querySearch(queryString, cb, item.name)" :placeholder="$t(item.placeholder)" :trigger-on-focus="false" @select="(item) => handleSelect(item, item.name, item.row)"></el-autocomplete>
                  <el-select size="mini" v-model="data[item.subName]" style="max-width: calc(56% - 2px); float: right" @change="(ev) => handleSelectChange(ev, item)">
                    <el-option v-for="subItem in item.option" :key="subItem.id" :label="$t(subItem.name)" :value="subItem.id"> </el-option>
                  </el-select>
                </template>
                <template v-else-if="item.type === 'selectAndSelect'">
                  <el-select size="mini" v-model="data[item.name]" style="max-width: calc(56% - 2px); float: left" @change="(ev) => handleSelectChange(ev, item)">
                    <el-option v-for="item1 in item.option" :key="item1.id" :label="item1.name" :value="item1.id"> </el-option>
                  </el-select>
                  <el-select size="mini" v-model="data[item.subName]" style="max-width: calc(44% - 2px); float: right" @change="(ev) => handleSelectChange(ev, item)">
                    <el-option v-for="item2 in item.subOption" :key="item2.id" :label="item2.name" :value="item2.id"> </el-option>
                  </el-select>
                </template>
                <template v-else-if="item.type === 'currencyAndInput'">
                  <currency-select v-model="data[item.subName]" :form-key="item.subName" :placeholder="$t(item.placeholder)" :disabled="item.disabled || false" style="max-width: calc(50% - 2px); float: left" @change="(ev, option) => $emit('currencySelect', ev, option, item)"></currency-select>
                  <money-input v-model="data[item.name]" :currencyId="data[item.currencyId]" :disabled="item.moneyDisabled || false" :placeholder="$t(item.mark) || $t(item.placeholder)" style="max-width: calc(50% - 2px); float: right" :suffix="item.suffix || null" :prefix="item.prefix || null"></money-input>
                </template>
                <el-checkbox v-else-if="item.type === 'singleCheckbox'" v-model="data[item.name]">{{ $t(item.placeholder) }}</el-checkbox>
                <el-radio-group :class="[item.align ? `align-${item.align}` : '']" v-model="data[item.name]" :disabled="item.disabled" v-else-if="item.type === 'radio'" @change="(e) => changeRadio(e, item, data)">
                  <el-radio v-for="(subItem, index) in item.option" :key="index" :label="subItem.id" :value="subItem.id" :disabled="subItem.disabled" :style="subItem.styleObject">
                    <template v-if="subItem.popover">
                      <el-popover :placement="subItem.placement || 'bottom'" :title="subItem.title || ''" :width="subItem.width || '200'" :trigger="subItem.trigger || 'hover'">
                        <div v-html="subItem.popoverContent"></div>
                        <span slot="reference">{{ $t(subItem.name) }}</span>
                      </el-popover>
                    </template>
                    <span v-html="subItem.htmlContent" v-else-if="subItem.type === 'html'"></span>
                    <span v-else>{{ $t(subItem.name) }}</span>
                  </el-radio>
                </el-radio-group>
                <el-date-picker size="mini" v-else-if="item.type === 'date'" v-model="data[item.name]" type="date" value-format="timestamp" format="yy/MM/dd"></el-date-picker>
                <el-date-picker size="mini" v-else-if="item.type === 'dateMonth'" v-model="data[item.name]" type="month" value-format="yyyyMM" format="yy/MM"></el-date-picker>
                <el-date-picker size="mini" v-else-if="item.type === 'daterange'" v-model="data[item.name]" type="daterange" :range-separator="$t('portal.zhi')" :start-placeholder="$t('portal.kai-shi')" :end-placeholder="$t('portal.jie-shu')" value-format="timestamp" format="yy/MM/dd" prefix-icon="false" :picker-options="item.pickerOptions" style="width: 100%">
                </el-date-picker>
                <el-date-picker size="mini" v-else-if="item.type === 'datetimerange'" v-model="data[item.name]" type="datetimerange" range-separator="-" :start-placeholder="item.start_placeholder" :end-placeholder="item.end_placeholder" value-format="timestamp" format="yy/MM/dd-HH:mm:ss" @input="changeDate" :picker-options="item.pickerOptions" style="width: 100%">
                </el-date-picker>
                <el-date-picker size="mini" v-else-if="item.type === 'timestamp'" v-model="data[item.name]" type="datetime" value-format="timestamp" format="yy/MM/dd HH:mm:ss"></el-date-picker>
                <template v-else-if="item.type === 'foreverDate'">
                  <el-date-picker size="small" v-model="data[item.name]" style="width: 140px" type="date" value-format="timestamp" format="yy/MM/dd" :disabled="data[item.foreverName]" :placeholder="$t('portal.xuan-ze-ri-qi')" :picker-options="item.pickerOptions" @change="foreverDateChange($event, 'datePicker', item, data)">
                  </el-date-picker>
                  <el-checkbox v-model="data[item.foreverName]" style="margin-left: 10px" @change="foreverDateChange($event, 'foreverCheckbox', item, data)">{{$t('portal.yong-jiu-you-xiao')}}</el-checkbox>
                </template>
                <template v-else-if="item.type === 'mutiInput'">
                  <el-input size="mini" :type="item.inputType || 'text'" v-model="data[item.name]" :placeholder="$t(item.placeholder)" style="width: calc(50% - 2px); float: left"></el-input>
                  <el-input size="mini" :type="item.inputType || 'text'" v-model="data[item.subName]" :placeholder="item.subPlaceholder" style="width: calc(50% - 2px); float: right"></el-input>
                </template>
                <template v-else-if="item.type === 'mutiComplete'">
                  <div style="display: flex">
                    <el-autocomplete size="mini" style="width: 50%" v-model="data[item.name]" :fetch-suggestions="(queryString, cb) => querySearch(queryString, cb, item.name, item)" :placeholder="$t(item.placeholder)" :trigger-on-focus="false" @select="(sel) => handleSelect(sel, item.name, data)"></el-autocomplete>
                    <el-autocomplete size="mini" style="width: 50%" v-model="data[item.subName]" :fetch-suggestions="(queryString, cb) => querySearch(queryString, cb, item.subName, item)" :placeholder="item.subPlaceholder" :trigger-on-focus="false" @select="(sel) => handleSelect(sel, item.name, data)"></el-autocomplete>
                  </div>
                </template>
                <template v-else-if="item.type === 'phoneSelf'">
                  <div class="phoneSelf">
                    <country-code-select class="phoneSelfCode" v-model="data[item.name+ '_code']" slot="prepend" :placeholder="$t('portal.qu-hao')" style="width: 60px" />
                    <el-input class="phoneSelfInput" :placeholder="$t(item.placeholder)"  v-model="data[item.name]" ></el-input>
                  </div>
                </template>
                <template v-else-if="item.type === 'phone'">
                  <el-input :placeholder="$t('portal.qu-hao')" v-model="countryCode.phone.city" maxlength="5" minlength="2" class="sel2ipt" autocomplete="off">
                    <country-code-select v-model="countryCode.phone.area" slot="prepend" :placeholder="$t('portal.qing-xuan-ze')" style="width: 95px"></country-code-select>
                    <el-input :placeholder="'请您输入' + $t(item.placeholder)" slot="append" v-model="countryCode.phone.number" :maxlength="item.maxlength" :minlength="item.minlength" autocomplete="off">
                    </el-input>
                  </el-input>
                </template>
                <template v-else-if="item.type === 'mobile'">
                  <el-input :placeholder="'请您输入' + $t(item.placeholder)" v-model="countryCode.mobile.number" :maxlength="item.maxlength" :minlength="item.minlength" autocomplete="off">
                    <country-code-select v-model="countryCode.mobile.area" slot="prepend" :placeholder="$t('portal.qing-xuan-ze')" style="width: 95px"></country-code-select>
                  </el-input>
                </template>
                <template v-else-if="item.type === 'fax'">
                  <el-input :placeholder="$t('portal.qu-hao')" v-model="countryCode.fax.city" maxlength="5" minlength="2" class="sel2ipt" autocomplete="off">
                    <country-code-select v-model="countryCode.fax.area" slot="prepend" :placeholder="$t('portal.qing-xuan-ze')" style="width: 95px"></country-code-select>
                    <el-input :placeholder="'请您输入' + $t(item.placeholder)" slot="append" v-model="countryCode.fax.number" :maxlength="item.maxlength" :minlength="item.minlength" autocomplete="off"></el-input>
                  </el-input>
                </template>
                <template v-else-if="item.type === 'currency'">
                  <span v-if="item.subType === 'readonly'">{{ data[item.tip] }}</span>
                  <currency-select v-else :disabled="item.disabled" v-model="data[item.name]" :ref="`${item.name}`" :form-key="item.name" :placeholder="$t(item.placeholder)" @change="(ev, options) => handleSelectChange(ev, { ...item, options })"></currency-select>
                </template>
                <template v-else-if="item.type === 'default-select'">
                  <span v-if="item.subType === 'readonly'">{{ data[item.tip] }}</span>
                  <default-select v-else v-model="data[item.name]" :visible="visible" :disabled="item.disabled" @change="(ev) => handleSelectChange(ev, item)"></default-select>
                </template>
                <template v-else-if="item.type === 'autocomplete'">
                  <el-autocomplete v-if="item.subName" size="mini" style="width: 100%" v-model="data[item.name][item.subName]" :class="{ 'un-match': data[item.name]['matched'] }" :fetch-suggestions="(queryString, cb) => querySearch(queryString, cb, item.name)" :placeholder="$t(item.placeholder)" :trigger-on-focus="false" @select="(e) => handleSelect(e, item.name, item.row)"></el-autocomplete>
                  <!-- 带输入建议 -->
                  <el-autocomplete v-else size="mini" style="width: 100%" v-model="data[item.name]" :fetch-suggestions="(queryString, cb) => querySearch(queryString, cb, item.name, item)" :placeholder="$t(item.placeholder)" :trigger-on-focus="false" @focus="(e) => focusAuto({ e, ref: `${item.name}_auto`, value: data[item.name] })" @select="(e) => handleSelect(e, item.name, data)" :ref="`${item.name}_auto`"></el-autocomplete>
                </template>
                <template v-else-if="item.type === 'supPack'">
                  <sup-pack v-model="data[item.name]" :data="data" :item="item" @getValue="(value, id, data) => $emit('supPackCallback', value, id, data)"></sup-pack>
                </template>
                <template v-if="item.type === 'address'">
                  <div :class="[item.showDetailAddress ? 'address-wrapper' : '']">
                    <region v-model="data[item.name]"></region>
                    <template v-if="!item.noShowNext">
                      <el-input :placeholder="$t('portal.jie-dao')" v-model="data[item.subName]" autocomplete="off" style="width: 100%"></el-input>
                      <el-input :placeholder="$t('portal.men-pai')" v-model="data[item.sub_subName]" autocomplete="off" style="width: 100%"></el-input>
                    </template>
                    <template v-if="item.showDetailAddress">
                      <el-input :placeholder="$t('portal.xiang-xi-di-zhi')" v-model="data[item.subName]" class="detail-address-input" autocomplete="off"></el-input>
                    </template>
                  </div>
                </template>
                <template v-else-if="item.type === 'postcode'">
                  <el-select :placeholder="$t('portal.you-bian')" v-model="data[item.name]" style="width: 100%">
                    <el-option value="1515">{{$t('portal.zhong-guo')}}</el-option>
                    <el-option value="1516">{{$t('portal.mei-guo')}}</el-option>
                    <el-option value="1517">{{$t('portal.ying-guo')}}</el-option>
                  </el-select>
                </template>

                <template v-else-if="item.type === 'readonly'">
                  <readonly :data="data" :item="item" class="edit-readonly" @selectLinkClick="(val, option) => selectLinkClick(val, option)">
                    <template v-if="item.subType === 'isSlot'">
                      <slot :name="item.slotName" :slot="item.slotName" :data="{value:data[item.name]}"></slot>
                    </template>
                  </readonly>
                </template>
                <template v-else-if="item.type === 'textarea'">
                  <el-input show-word-limit :maxlength="item.maxlength" type="textarea" :rows="item.rows" :placeholder="$t(item.mark) || $t(item.placeholder)" v-model="data[item.name]" @focus.stop="(ev) => handleFocus(ev, item)">
                  </el-input>
                </template>
                <template v-else-if="item.type === 'attachment'">
                  <file-upload v-model="data[item.name]" :file-type="item.fileType" :file-size="item.fileSize" :accept="item.accept" :message="item.message" :theme="item.theme"></file-upload>
                </template>
                <template v-else-if="item.type === 'attachmentOne'">
                  <UploadClassOne v-model="data[item.name]" :multiple="item.multiple" :limit="item.limit" :file-type="item.fileType" :file-size="item.fileSize" :accept="item.accept" :message="item.message" :theme="item.theme" :tip="!item.noTip" @onProgress="fileUploadOnProgress" @onChange="fileUploadOnChange" @onRemove="fileUploadOnRemove" @uploaded="fileUploaded">
                </UploadClassOne></template>
                <template v-else-if="item.type === 'img'">
                  <base-avatar :img-url="form[item.prop]" @img-change="imgChange"></base-avatar>
                </template>
                <template v-else-if="item.type === 'region'">
                  <region v-model="data[item.name]" @input="regionCallback"></region>
                </template>
                <template v-else-if="item.type === 'category'">
                  <category v-model="data[item.name]" :rid="data[item.rid]" :categoryValue="data[item.tip]" :categoryType="item.categoryType" @select="(ev) => handleSelectChange(ev, item)" :clearable="item.clearable" :placeholder="$t(item.placeholder)" @callback="(id, name) => $emit('categoryCallback', id, name)"></category>
                </template>
                <template v-else-if="item.type === 'selectContact'">
                  <SelectContact v-bind="{ ...item }" v-model="data[item.name]" @selectChange="(ev, res) => handleSelectChange(ev, { ...item, ...res }, 'selectContact')"></SelectContact>
                </template>
                <template v-else-if="item.type === 'tag'">
                  <tag-input v-model="data[item.name]" :split="item.split" :placeholder="$t(item.mark)" :suffix="item.suffix"></tag-input>
                </template>
                <template v-else-if="item.type === 'money'">
                  <money-input v-model="data[item.name]" :currencyId="data[item.currencyId]" :placeholder="$t(item.mark) || $t(item.placeholder)" :suffix="item.suffix || null" :prefix="item.prefix || null" :disabled="item.disabled || false" @blur="({ e, value }) => textInputBlur({ e, value, item, data })" @input="(ev) => (item.input ? item.input(ev) : () => {})"></money-input>
                </template>
                <template v-else-if="item.type === 'number'" >
                  <el-input v-model.number="data[item.name]" :placeholder="$t(item.placeholder)" :disabled="!!item.disabled" @blur="e => numberBlur(e, item, data)">
                    <template v-if="item.suffix">
                      <span slot="suffix" :class="item.suffix.class">{{ item.suffix.content }}</span>
                    </template>
                  </el-input>
                </template>
                <template v-else-if="item.type === 'numberPoint'">
                  <el-input v-model.number="data[item.name]" type="number" :placeholder="$t(item.placeholder)" :disabled="item.disabled" @change="changeNumberPoint($event, item, data)">
                    <template v-if="item.suffix">
                      <span slot="suffix" :class="item.suffix.class">{{ item.suffix.content }}</span>
                    </template>
                  </el-input>
                </template>
                <template v-else-if="item.type === 'isSlot'">
                  <slot :name="item.slotName" :data="{value:data[item.name]}" />
                </template>
                <template v-else-if="item.type === 'fileLink' && data[item.name] && data[item.name].length > 0">
                  <a class="u-val ic-color" :style="{ 'max-width': getValWidth, color: '#2469c6' }" :href="`/rest/store/general/v3/image/${data[item.name][0].ipfs}`" :download="`${data[item.name][0].file_name}`" :title="`${data[item.name][0].file_name}`">
                    {{ data[item.name][0].file_name }}
                  </a>
                </template>
                <span v-else-if="item.type === 'todo'" style="text-align: left; display: block">TODO</span>
                <template v-else-if="item.type === 'select_input'">
                  <el-select size="mini" v-model="data[item.selectObj.id]" style="width: 55%" :filterable="item.filterable" :remote="item.remote || false" @visible-change="(ev) => handleVisibleChange(ev, item)" @change="(ev) => handleSelectChange(ev, item, data)" @focus="(ev) => handleSelectFocus(ev, item)" @blur="(ev) => handleSelectBlur(ev, item)" :remote-method="item.remoteMethod" :loading="item.selectObj.loading || false" :disabled="item.selectObj.disabled" :clearable="item.selectObj.clearable" :multiple="item.multiple || false" :collapse-tags="item.collapse || false" :reserve-keyword="item.reserveKeyword || false" :placeholder="item.selectObj.notice || $t('tip.select')" :id="item.selectObj.id" :ref="`${item.selectObj.id}`" :allow-create="item.allowCreate || false" :value-key="item.selectObj.valueKey">
                    <div v-if="item.multiple && item.checkAll && item.option.length > 1" class="check-all-wrapper">
                      <el-checkbox v-model="item.checked" @change="(ev) => handleCheckAllChange(ev, item)">{{$t('portal.quan-xuan')}}</el-checkbox>
                    </div>
                    <el-option v-for="(subItem, index) in item.option" :key="index" :disabled="subItem.disabled" :label="subItem[item.label] || $t(subItem.name)" :value="item.valueKey ? subItem : subItem.id" :title="subItem.other ? subItem.other : $t(subItem.name)">
                      {{ item.label ? subItem[item.label] : subItem.other ? subItem.other : $t(subItem.name) }}
                    </el-option>
                  </el-select>
                  <el-input size="mini" style="width: 40%" :type="item.inputObj.inputType || 'text'" :disabled="item.inputObj.disabled || false" v-model="data[item.inputObj.id]" :placeholder="item.inputObj.mark || item.inputObj.placeholder" :show-password="item.inputObj.showPassword || false" :autocomplete="item.inputObj.autocomplete || 'off'" :maxlength="item.inputObj.maxlength" @change="(ev) => (item.change ? item.change(ev) : () => {})" @input="(ev) => (item.input ? item.input(ev) : () => {})" @blur="(e) => textInputBlur({ e, item, value: data[item.inputObj.id] })">
                    <template v-if="item.suffix && item.suffix.tag === 'span'">
                      <span slot="suffix" :class="item.suffix.class">{{ item.suffix.content }}</span>
                    </template>
                  </el-input>
                </template>
              </el-form-item>
            </el-col>
          </el-form>
        </el-row>
        <!-- 只读区 -->
        <el-row class="content" :gutter="24" v-else>
          <el-col class="el-col__self custom-style" v-for="(item, index) in option.field" :span="item.span ? item.span : 24" :offset="item.offset" :pull="item.pull" :key="index" :class="item.colClassName ? item.colClassName : ''" :style="{ clear: item.clear ? item.clear : 'none' }" @mouseenter.native="colMouseenter">
            <div class="line" v-if="item.type === 'line'"></div>
            <div class="none-display" v-else-if="item.showAsEdit"></div>
            <div v-else-if="item.type === 'group'" style="display: block">
              <div v-for="(subItem, index) in item.children" :key="index">
                <label class="u-label" :style="{ width: item.labelWidth || getLabelWidth }">
                  {{ $t(subItem.placeholder) }}
                </label>
                <span class="u-val" :style="{ 'max-width': getValWidth }" v-if="subItem.type === 'date'">
                  {{ data[subItem.name] | filterTimeToFormatTime }}
                </span>
                <span class="u-val" :style="{ 'max-width': getValWidth }" v-else-if="subItem.type === 'todo'"> TODO </span>
                <span class="u-val" :style="{ 'max-width': getValWidth }" v-else>
                  {{ data[subItem.name] }}
                </span>
              </div>
            </div>
            <div v-else-if="item.type === 'text'">
              <span class="u-label" :style="{ width: item.labelWidth || getLabelWidth }" :class="item.labelClassName ? item.labelClassName : ''">
                {{ $t(item.placeholder)?$t(item.placeholder):item.name }}
              </span>
              <span class="u-val pointer" v-if="item.click" @click="clickCell" :style="{ 'max-width': getValWidth }" style="color: #2469c6">{{ data[item.name] || '' }}</span>
              <span class="u-val" v-else >{{ data[item.name] || '' }}</span>
              <template v-if="item.subType === 'isSlot'">
                <slot :name="item.slotName" :slot="item.slotName" :data="{value:data[item.name]}"></slot>
              </template>
            </div>
            <div v-else-if="item.type === 'fill'" :style="{ height: item.height + 'px' }"></div>
            <div v-else class="widthControl" :class="{ hasCopy: item.copy }">
              <span class="u-label" :style="{ width: item.labelWidth || getLabelWidth }" :class="item.labelClassName ? item.labelClassName : ''">
                {{ $t(item.placeholder) }}
              </span>
              <span class="u-val" v-if="item.type === 'todo'" :style="{ 'max-width': getValWidth }"> TODO </span>
              <span class="u-val" v-else-if="item.type === 'textarea'" :style="{ 'max-width': getValWidth }" :class="item.type == 'textarea' ? 'h200' : ''">
                <el-tooltip class="item" effect="light" :content="data[item.name]" placement="top-start">
                  <span class="textarea-style">{{ data[item.name] || '' }}</span>
                </el-tooltip>
              </span>
              <a v-else-if="item.type === 'attachment'" :href="data[item.ipfs]?'/rest/store/general/v3/image/' + data[item.ipfs]:'#'" :download="data[item.file_name]" class="u-val ic-color" :style="{ 'max-width': getValWidth, color: '#2469C6' }">
                <div @click="()=> $emit('attachmentDownload', data.id,data[item.ipfs]?'/rest/store/general/v3/image/' + data[item.ipfs]:'#')">{{ data[item.file_name] }}</div>
              </a>
              <a v-else-if="item.type === 'fileLink' && data[item.name] && data[item.name].length > 0" class="u-val ic-color" :style="{ 'max-width': getValWidth, color: '#2469c6' }" :href="`/rest/store/general/v3/image/${data[item.name][0].ipfs}`" :download="`${data[item.name][0].file_name}`" :title="`${data[item.name][0].file_name}`">
                {{ data[item.name][0].file_name }}
              </a>
              <span class="u-val" v-else-if="item.type === 'readonly'" :class="item.readonlyValClass||''" :style="{ 'max-width': getValWidth }">
                <readonly :data="data" :item="item" @selectLinkClick="(val, option) => selectLinkClick(val, option)">
                  <template v-if="item.subType === 'isSlot'">
                    <slot :name="item.slotName" :slot="item.slotName" :data="{value:data[item.name]}"></slot>
                  </template>
                </readonly>
                <slot name="customContent" v-if="item.subType === 'customContent'"></slot>
              </span>
              <span class="u-val pointer" v-else-if="item.type === 'button'" @click="addSlug" :style="{ 'max-width': getValWidth }" style="color: #2469c6">{{$t('portal.Slug-url-lian-jie')}}</span>
              <span class="u-val pointer" v-else-if="(item.type === 'url' || item.type === 'link') && data[item.name]" :style="{ 'max-width': getValWidth }" @click="(ev) => showSlug(ev, item, data[item.name], data)" style="color: #2469c6">
                <el-tooltip class="item" effect="light" :content="data[item.name]" placement="top">
                  <span>{{ data[item.name] }}</span>
                </el-tooltip>
              </span>
              <span class="u-val" v-else-if="item.type === 'date' || item.type === 'foreverDate'" :style="{ 'max-width': getValWidth }">
                {{ data[item.name] | filterTimeToFormatTime }}
              </span>
              <span class="u-val" v-else-if="item.type === 'timestamp'" :style="{ 'max-width': getValWidth }">
                {{ data[item.name] | filterTimeToFormatTime('YY/MM/DD-HH:mm:ss') }}
              </span>
              <span class="u-val" v-else-if="item.type === 'cascader'" :style="{ 'max-width': getValWidth }">
                <el-tooltip class="item" effect="light" :content="data[item.tip] || data[item.name]" placement="top">
                  <span>{{ data[item.tip] || data[item.name] }}</span>
                </el-tooltip>
              </span>
              <span class="u-val" v-else-if="item.type === 'select'" :style="{ 'max-width': getValWidth }">
                <el-tooltip v-if="item.title" :content="data[item.title]" effect="light" placement="top" :style="item.style">
                  <span>
                    {{ (data[item.tip] || data[item.name]) | filterData(item) }}
                  </span>
                </el-tooltip>
                <span v-else-if="item.showText">
                  {{ data[item.name] }}
                </span>
                <span v-else>
                  {{ (data[item.tip] || data[item.name]) | filterData(item) }}
                </span>
              </span>
              <span class="u-val" v-else-if="item.type === 'selectMultiple'" :style="{ 'max-width': getValWidth }" :title="item.title ? data[item.title] : Array.isArray(data[item.tip]) ? data[item.tip].join(',') : data[item.tip]||''">
                {{ Array.isArray(data[item.tip]) ? data[item.tip].join(',') : data[item.tip]||''}}
              </span>
              <span class="u-val" v-else-if="item.type === 'daterange'" :style="{ 'max-width': getValWidth }">
                {{ data[item.date_start] | filterTimeToFormatTime }}-{{ data[item.date_end] | filterTimeToFormatTime }}
              </span>
              <span class="u-val" v-else-if="item.type === 'datetimerange'" :style="{ 'max-width': getValWidth }">
                {{ data[item.date_start] | filterTimeToFormatTime('YY/MM/DD-HH:mm:ss') }} - {{ data[item.date_end] | filterTimeToFormatTime('YY/MM/DD-HH:mm:ss') }}
              </span>
              <span class="u-val" v-else-if="item.type === 'currency'" :style="{ 'max-width': getValWidth }">
                {{ data[item.name] | formatCurrency }}
              </span>
              <span class="u-val" v-else-if="item.type === 'region' || item.type === 'address'" :style="{ 'max-width': getValWidth }">
                <template v-if="item.title">
                  <el-tooltip :content="data[item.title]" effect="light" placement="top"><span>{{ data[item.tip] }}</span></el-tooltip>
                </template>
                <template v-else>
                  {{ data[item.tip] }}
                </template>
              </span>
              <span class="u-val" v-else-if="item.type === 'selectAndSelect'" :style="{ 'max-width': getValWidth }">
                {{ data[item.name]| filterData({ ...item, type: "select" })}},{{ data[item.subName] | filterData({ option:item.subOption, type: "select" })}}
              </span>
              <span class="u-val" v-else-if="item.type === 'money' || item.type === 'currencyAndInput'" :style="{ 'max-width': getValWidth }">
                {{ data[item.name] | formatMoney(data[item.currencyId], '', item.isDcode, item.noSymbol, item.noThousands, item.remainNum) }}
              </span>
              <span class="u-val" v-else-if="item.type === 'tag'" :style="{ 'max-width': getValWidth }" :title="data[item.name] ? data[item.name].join(',') : ''">
                {{ data[item.name] ? data[item.name].join(',') : '' }}
              </span>
              <span class="u-val" v-else-if="item.type === 'number' || item.type === 'numberPoint'" :style="{ 'max-width': getValWidth }">
                {{ data[item.name] | formatNumber }}<span v-if="item.suffix" :class="item.suffix.class">{{ item.suffix.content }}</span>
              </span>
              <span class="u-val" v-else :style="{ 'max-width': getValWidth }" :title="(data[item.tip] || data[item.name]) | filterData(item)" :class="item.type == 'address' ? 'h200' : ''">
                <div :style="item.parentStyle" v-if="item.formatter && item.vHtml" v-html="
                    item.formatter({
                      row: data,
                      column: item.id,
                      cellValue: data[item.id]
                    })
                  "></div>
                <template v-else>
                  <span :style="item.readStyle ? {...item.readStyle} : ''">{{ (data[item.tip] || data[item.name]) | filterData(item) }}</span>
                  <template v-if="item.suffix && item.suffix.tag === 'span'">
                    <span slot="suffix" :class="item.suffix.class">{{ item.suffix.content }}</span>
                  </template>
                </template>
              </span>
            </div>
            <i class="icon el-icon-copy-document" :title="$t('button.copy')" v-show="item.copy" @click="copyMsg(data[item.name])"></i>
            <img @click="showQcc" src="~~/common/assets/img/qcc.png" alt="" v-if="item.qcc"  style="cursor:pointer;display:inline-block;width:15px;top:3px;position:relative;">
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <slot name="otherContent"></slot>
        </el-row>
      </div>
      <div class="right-box" v-show="option.showBanner">
        <!-- 创建部分 -->
        <div class="right-btn-box" v-if="option.create">
          <el-button class="t-r-btn" @click="save" size="mini">{{$t('button.save')}}</el-button>
          <el-button class="t-r-btn" @click="() => $emit('close')" size="mini">{{$t('button.cancel')}}</el-button>
        </div>
        <div class="right-btn-box" v-if="!option.isAdd && option.btnPosition !== 'top' && data && JSON.stringify(data) !== '{}' && !option.create">
          <el-button v-if="option.edit && !option.isEdit" v-auth:update="option.authRoute || ''" :disabled="option.disabled" :class="['t-r-btn', { 'btn-disabled': option.disabled }]" @click="change" size="mini">
            {{$t(option.editType) || $t('button.edit')}}
          </el-button>
          <slot name="buttonBefore"></slot>
          <div v-if="option.isEdit">
            <el-button class="t-r-btn" @click="save" size="mini">{{$t(option.saveBtnText) || $t('button.save')}} </el-button>
            <el-button class="t-r-btn" @click="cancelChange" size="mini">{{$t('button.cancel')}}</el-button>
          </div>
          <!-- 在编辑按钮后新增一个插槽，用于其他合适的情况下操作 -->
          <slot name="buttonAfter"></slot>
          <template v-if="!option.isEdit">
            <slot name="button"></slot>
          </template>
          <el-popover placement="bottom" width="150" v-if="option.moreBtn && !option.isEdit" trigger="click">
            <el-button size="mini" class="t-r-btn" slot="reference">{{$t('nav.more')}}</el-button>
            <div class="btn-box">
              <slot name="moreBtn"></slot>
            </div>
          </el-popover>
        </div>
        <slot name="right"></slot>
      </div>
    </div>
    <div class="footer-btn-box" v-if="option.isAdd" :class="{ 'right-bottom': option.showClose }">
      <template v-if="option.showClose">
        <el-button class="dio-btn close-btn" size="mini" @click="cancelChange">{{$t('portal.guan-bi')}}</el-button>
      </template>
      <template v-else>
        <el-button v-if="option.baocun" class="dio-btn" size="mini" :loading="option.baocunLoading" type="primary" @click="e =>save(e,{baocun:true})" :disabled="saveDisabled">保存</el-button>
        <el-button class="dio-btn" size="mini" :loading="isSubmitting" type="primary" @click="save" :disabled="saveDisabled">{{option.isAddHtml ? $t(option.isAddHtml) : $t('button.save')}}</el-button>
        <el-button class="dio-btn" size="mini" @click="cancelChange" v-if="!option.shouCancel">{{$t('button.cancel')}}</el-button>
        <slot name="footer-button"></slot>
      </template>
    </div>
  </div>
</template>

<script>
/**
 * 基础信息组件
 *
 * 使用说明：
 * 1，导入组件：import BaseInfo from "~/common/components/tab/BaseInfo.vue"
 * 2，注册组件：components: {BaseInfo}
 * 3，渲染：<base-info :option="option" :data="baseInfo" @save="save"></base-info>
 *
 * 属性说明：
 * left: 头像组件
 * center: 基础信息
 * right: 广告位组件
 * center：
 *       :option : Object 基础信息基本配置项
 *       :data：Object 基础信息数据对象
 *       @save: function 点击保存按钮事件--参数：Object 当前保存数据对象
 *
 * 数据说明：
 * submitting: Boolean 提交的状态，赋值给原有的isSubmitting ，确保失败时，可以再次点击
 * 注意：$emit('save')时父组件要手动修改submitting为true,否则两次都是false,watch失效
 * option: {
 *   field:[],  字段配置
 *   rules：{}， 验证规则
 *   edit：true，设置是否可编辑
 *   disabled：true，有编辑按钮但是禁用不可点
 *   isEdit：true，设置编辑状态
 *   isAdd: true，设置是否是新增
 *   moreBtn: true，设置是否是更多按钮
 *   showLogo：true，设置是否显示头像
 *   showBanner: true，设置是否显示广告位
 *   editType: "编辑" 编辑按钮的文字  缺省就是"编辑" 比如可以是变更
 *   authRoute: '' 权限路由路径，设置编辑按钮权限，不传值 默认展示，用法: v-auth:update="option.authRoute || ''"
 * }
 * option.field：[{  /过滤器基本配置项数据
 *      type: "text", //输入框类型：text普通输入框，link可编辑链接，select下拉输入框，selectMultiple下拉输入框，date时间选择输入框，currency币种选择，attachment附件上传，fileLink文件链接，foreverDate带永久日期的日期选择，TODO未开发
 *      placeholder: "型号", //输入框提示
 *      name: "sku_name", //绑定的字段名与baseInfo里面的键对应
 *      key: "f_sku_name", //循环唯一标识key
 *      span: number, //设置显示宽度
 *      fileType: "file", // type为attachment时可指定输出类型, 可选file|url|ipfs
 *      title:  气泡框需要显示的字段
 *      heightInitial:高度取自身
 *  }]
 * 210331添加moreBtn插槽，用于存放更多按钮
 */
import { mapState } from 'vuex';
import CurrencySelect from '~/common/components/select/CurrencySelect.vue';
import DefaultSelect from '~/common/components/select/DefaultSelect.vue';
import CountryCodeSelect from '~/common/components/select/CountryCodeSelect.vue';
import FileUpload from '~/common/components/upload/FileUpload.vue';
import Region from '~/common/components/custom/Region.vue';
import Addresses from '~/common/components/custom/Addresses.vue';
import ContactInfo from '~/common/components/custom/ContactInfo.vue';
import TagInput from '~/common/components/custom/TagInput.vue';
import MoneyInput from '~/common/components/custom/MoneyInput.vue';
import Category from '~/common/components/custom/Category.vue';
import SelectContact from '~/common/components/custom/SelectContact.vue';
import readonly from './readonly';
import SupPack from '~/common/components/custom/SupPack.vue';
import UploadClassOne from '~/common/components/upload/UploadClassOne.vue';
import checkSelect from './checkSelect';
import moment from 'moment';
export default {
  name: 'BaseInfo',
  components: {
    CurrencySelect,
    DefaultSelect,
    CountryCodeSelect,
    FileUpload,
    Region,
    TagInput,
    Category,
    MoneyInput,
    readonly,
    Addresses,
    ContactInfo,
    SupPack,
    SelectContact,
    checkSelect,
    UploadClassOne
  },
  props: {
    drawerLevel: {
      //当前组件所在的侧拉抽屉层级
      type: [Number, String],
      default: 0
    },
    isEmployee: {
      //是否是员工账户
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      default() {
        return {};
      }
    },
    option: {
      type: Object,
      required: true
    },
    submitting: {
      type: Boolean,
      default() {
        return false;
      }
    },
    visible: {
      type: Boolean,
      default() {
        return false;
      }
    },
    line: {
      type: Number,
      default() {
        return 5;
      }
    },
    saveDisabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isEdit: false,
      slug: false,
      isSubmitting: this.submitting ? true : false,
      countryCode: {
        mobile: {
          area: '86',
          number: ''
        },
        phone: {
          area: '86',
          city: '',
          number: ''
        },
        fax: {
          area: '86',
          city: '',
          number: ''
        }
      },
      addressObj: {
        address: [],
        street_address: '',
        building_address: ''
      },
      optionsOri: [],
      options: [],
      needHheightAuto: ['textarea', 'address', 'addresses', 'contact_info'],
      queryId: '',
      timer: null,
      maxWidth:0
    };
  },
  computed: {
    ...mapState({
      isSpread: state => state.isSpread,
      isSubSpread: state => state.isSubSpread
    }),
    //获取传入的labelWidth  作为u-label的长度  默认90
    //labelWidth = 字数 *14 + 12（padding）
    getLabelWidth() {
      return (this.option.maxLabelWidth ? this.option.maxLabelWidth : this.maxWidth) + 'px';
    },
    getValWidth() {
      //el-col 左右边距12 设置max-width
      return `calc(100% - ${this.option.maxLabelWidth ? this.option.maxLabelWidth : this.maxWidth}px)`;
    }
  },
  methods: {
    numberBlur(e, item, data){
      this.$emit('numberBlur', {e, item, data})
    },
    fileUploadOnProgress(file) {
      this.$emit('fileUploadOnProgress', file);
    },
    fileUploadOnChange(file, fileList) {
      this.$emit('fileUploadOnChange', file, fileList);
    },
    fileUploadOnRemove(file, fileList) {
      this.$emit('fileUploadOnRemove', file, fileList);
    },
    fileUploaded(file) {
      this.$emit('uploaded', file);
    },
    changeShow(e) {
      this.$emit('changeShow', e);
    },
    /**
     * 解决下拉框出隐藏时 不触发select的blur 导致校验失败
     */
    visibleChange(val, name) {
      if (!val) {
        this.$refs['baseInfo'].validateField([name]);
      }
    },
    // 主动触发表单校验
    validateField(arrName = []) {
      this.$refs['baseInfo'].validateField(arrName);
    },
    //移除校验结果
    resetForm() {
      this.$refs['baseInfo'].clearValidate();
    },
    //字段值重置,移除校验结果
    resetField() {
      this.$refs['baseInfo'].resetFields();
      const clearArr = ['contact_info', 'addresses'];
      this.option.field.map(v => {
        if (clearArr.includes(v.type)) {
          this.$set(this.data, v.name, null);
        }
      });
    },
    changeRadio(e, item, data) {
      this.$emit('changeRadio', e, item, data);
    },
    //带建议输入匹配查询
    querySearch(queryString, cb, id, item) {
      this.$emit('autocomplete-search', {
        queryString,
        cb,
        id,
        item
      });
    },
    focusAuto({
      e,
      ref,
      value
    }) {
      //有默认值时，获取焦点，主动触发下拉
      if (this.$refs[ref] && this.$refs[ref][0]) {
        this.$refs[ref][0].activated = true;
        this.$refs[ref][0].getData(value);
      }
    },
    //带建议输入选中一条建议
    handleSelect(selected, id, row) {
      this.$emit('autocomplete-select', {
        selected,
        id,
        row
      });
    },
    change() {
      if (this.data.mobile) {
        let [area, number] = this.data.mobile.split('-');
        this.countryCode.mobile = {
          area: area,
          number: number
        };
      }
      if (this.data.phone) {
        let [area, city, number] = this.data.phone.split('-');
        this.countryCode.phone = {
          area: area,
          city: city,
          number: number
        };
      }
      if (this.data.fax) {
        let [area, city, number] = this.data.fax.split('-');
        this.countryCode.fax = {
          area: area,
          city: city,
          number: number
        };
      }
      this.option.isEdit = true;
      this.$emit('click-edit', this.option.isEdit);
    },
    cancelChange() {
      if (this.option.isAdd == true) {
        this.$emit('cancel');
      } else {
        this.option.isEdit = false;
        this.$emit('click-edit', this.option.isEdit);
      }
    },
    imgChange(data) {
      this.data.avatar = data;
    },
    // remoteMethod(query) {
    //   this.$emit("remote-method", query);
    // },
    handleSelectFocus(value, item) {
      this.$emit('focus', {
        ...item,
        value
      });
    },
    handleSelectBlur(value, item) {
      this.$emit('blur', {
        ...item,
        value
      });
    },
    handleSelectChange(value, item, data) {
      // 下拉select被选中时，提交事件，便于外层做联动
      if (item.linkage) {
        //判断联动项  primary为主，secondary为次
        const slug = item.linkage.split('-');
        if (slug[1] === 'primary') {
          this.option.field.map(v => {
            if (v.linkage && v.linkage === `${slug[0]}-secondary`) {
              this.$set(this.data, v.name, '');
              this.$set(v, 'option', []);
            }
          });
        }
      }
      this.$emit('selectChange', {
        ...item,
        data,
        value
      });
    },
    // 下拉框全选
    handleCheckAllChange(value, item) {
      this.$emit('checkAllChange', {
        value,
        ...item
      });
    },
    handleVisibleChange(value, item) {
      // select下拉框出现/隐藏时触发
      this.$emit('visibleChange', {
        ...item,
        value
      });
    },
    handleFocus(value, item) {
      // 聚焦选中时，提交事件
      this.$emit('focus', {
        ...item,
        value
      });
    },
    regionCallback(ids, text) {
      this.$emit('regionCallback', ids, text);
    },
    addSlug(type) {
      this.slug = true;
      this.$emit('addSlug', this.slug, type);
    },
    showSlug(ev, item, value, data) {
      this.showContent = true;
      this.$emit('showSlug', this.showContent, value);
      this.$emit('change', {
        ev,
        ...item
      });
      this.$emit('getInfo', data);
    },
    // 下拉可点击链接 (选中的值, 整个options)
    selectLinkClick(val, option) {
      this.$emit('selectLinkClick', val, option);
    },
    // 数字输入框变化时的事件
    changeNumberPoint(value, item, data) {
      // 如果item里定义了emit:true才向上传递事件。新增的事件，以免影响到以前的数字输入框
      if (item.emit) {
        this.$emit('numberPointChange', Number(value), item, data);
      }
    },
    // 带永久日期的日期选择框的change事件（日期框和复选框写进一个事件里）
    foreverDateChange(value, domType, item, data) {
      // 日期框的change事件
      if (domType === 'datePicker') {
        // 根据所选日期与默认永久日期对比，大于等于默认永久日期时，则把复选框勾上
        data[item.foreverName] = value >= item.foreverDate;
        // 将时间改为选中当天的23:59:59，以方便后台存储
        data[item.name] = new Date(`${moment(value).format('YYYY-MM-DD')} 23:59:59`).getTime();
      }
      // 复选框的change事件
      if (domType === 'foreverCheckbox') {
        // 如果手动勾选永久日期，则把日期框的时间设为默认永久日期
        if (value) {
          data[item.name] = item.foreverDate;
        }
      }
    },
    changeDate() {
      //解决日期组件赋默认值，选择日期后视图不更新的问题
      this.$forceUpdate();
    },
    validForm() {
      let f = true;
      this.$refs['baseInfo'].validate(valid => {
        if (valid) {
          f = true;
        } else {
          f = false;
        }
      });
      return f;
    },
    save(e,rest) {
      if (typeof e !== 'boolean') {
        e && e.stopPropagation(); //避免触发window上的click事件
      }
      let f = true;
      // 表单提交时校验通过才emit
      this.$refs['baseInfo'].validate(valid => {
        if (valid) {
          if (this.countryCode.mobile.number) {
            this.data.mobile = this.countryCode.mobile.area + '-' + this.countryCode.mobile.number;
          }
          // else if (this.data.mobile) {
          //   this.data.mobile = '';
          // }
          if (this.countryCode.phone.city && this.countryCode.phone.number) {
            this.data.phone = this.countryCode.phone.area + '-' + this.countryCode.phone.city + '-' + this.countryCode.phone.number;
          }
          // else if (this.data.phone) {
          //   this.data.phone = '';
          // }
          if (this.countryCode.fax.city && this.countryCode.fax.number) {
            this.data.fax = this.countryCode.fax.area + '-' + this.countryCode.fax.city + '-' + this.countryCode.fax.number;
          }
          // else if (this.data.fax) {
          //   this.data.fax = '';
          // }
          if (typeof e === 'boolean') {
            this.$emit('commitSave', this.data);
            f = false;
            return;
          }
        
          this.isSubmitting = true;
          // 提交数据
          this.$emit('save', rest ? {...this.data,...rest} :this.data);
          this.isSubmitting = this.submitting;
          f = true;
        } else {
          //   this.$message({
          //   message: '请完善必填项',
          //   type: 'error'
          // });
          f = false;
          return false;
        }
      });
      const els = document.getElementsByClassName('el-form-item__error');
      if (els) {
        this.$nextTick(() => {
          for (let i = 0; i < els.length; i++) {
            const el = els[i];
            el.classList.add('removeAni');
          }
        });
        clearTimeout(this.timer);
        this.timer = setTimeout(() => {
          for (let i = 0; i < els.length; i++) {
            const el = els[i];
            el.classList.remove('removeAni');
          }
        }, 100);
      }
      return f;
    },
    copyMsg(content) {
      const input = document.createElement('input');
      input.setAttribute('readonly', 'readonly');
      input.setAttribute('value', content);
      document.body.appendChild(input);
      input.select();
      if (document.execCommand('copy')) {
        document.execCommand('copy');
        this.$message.success(this.$t('portal.yi-fu-zhi'));
      }
      document.body.removeChild(input);
    },
    resetBlur({
      arr
    }) {
      //因为upload 会触发document.activeElement的focus,需要主动失焦
      arr.map(v => {
        if (this.$refs[`${v}`]?.[0]?.blur) {
          this.$refs[`${v}`][0].blur();
        }
      });
      // document.activeElement.blur()
    },
    textInputBlur({
      e,
      item,
      value,
      data
    }) {
      this.$emit('textInputBlur', {
        e,
        item,
        value,
        data
      });
    },
    clickCell() {
      this.$emit('clickCell');
    },
    colMouseenter(e) {
      const target = e.target;
      let uVal = target.getElementsByClassName('u-val');
      uVal = Array.from(uVal);
      if (uVal.length) {
        const cur = uVal[0];
        if (cur.scrollWidth > cur.clientWidth) {
          //超出了,且uval里面只有文本
          if (!/<[^>]*>/g.test(cur.innerHTML.trim())) {
            cur.setAttribute('title', cur.innerHTML);
          }
        }
      }
    },
    widthFn() {
      // 获得最长的字符。用来设定lable宽度，以满足大部分场景
      const lens = this.option.field.map(v => {
        if (v.placeholder === undefined) {
          return 0;
        } else if (v.children) {
          const childLens = v.children.map(val => `${val.placeholder}`.length);
          return Math.max(...childLens);
        } else {
          // 针对字母数字空格额外处理，长度为一半

          const charList = v.placeholder.match(/[a-zA-Z0-9]|\s/g);
          return charList ? `${v.placeholder}`.length - charList.length / 2 : `${v.placeholder}`.length;
        }
      });
      this.maxWidth = 14 * Math.max(...lens) + 20 + 6;
    },
    showQcc() {
      this.$emit('showQcc')
    },
  },
  mounted() {
    this.widthFn()
  },
  watch: {
    submitting(newVal) {
      //监听sbumitting, 确保添加失败时，btn->loading 为false，可以继续点击
      this.isSubmitting = newVal;
    },
    $route: {
      immediate: true,
      handler: function ({
        query
      }) {
        if (query.id) {
          this.queryId = query.id;
        }
      }
    }
  }
};
</script>
<style lang="less">
.base-info {
  padding: 4px 4px 0;
  background: #fff;
  text-align: left;
  .none-display {
    display: none;
  }
  .content-box {
    display: flex;
    position: relative;
    align-items: stretch;
    justify-content: flex-end;
    padding-bottom: 5px;

    & > div {
      height: 100%;

      &.left-box {
        width: 160px;
        margin-right: 10px;
        max-height: 180px;
        overflow: scroll;
        &::-webkit-scrollbar {
          display: none;
        }
      }

      &.right-box {
        width: 240px;
        height: 190px;
        margin-left: 10px;
        position: relative;
      }

      &.center-box {
        border: none;
        max-height: 190px;
        padding: 4px 9px 0 4px;
        overflow-y: auto;
        overflow-x: hidden;
        flex: 1;

        &.show-all {
          border: none;
          max-height: inherit;
        }
        &.sixLine {
          max-height: 250px;
        }
      }
    }
  }
  .el-col {
    font-size: @fz4;
    line-height: 26px;
    .el-form-item__error {
      padding-top: 0;
    }

    .line {
      border-bottom: 1px solid @lc;
      width: 100%;
      margin-bottom: 10px;
    }

    .el-date-editor.el-input {
      width: 100%;
    }

    .u-label {
      width: 90px;
      padding-right: 12px;
      color: @fc6;
      text-align: right;
      margin-bottom: 14px;
      text-decoration: underline;
      display: inline-block;
    }

    .u-val {
      // max-width: calc(100% - 114px);
      vertical-align: top;
      text-align: left;
      color: @fc6;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      display: inline-block;
      // margin-bottom: 14px;
    }

    .textarea-style {
      // line-height: 22px; 这里对不齐
      font-size: @fz4;
      color: @fc6;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      overflow: hidden;
      max-height: 62px;
    }

    .h200 {
      height: 60px;
      white-space: normal;
    }

    .el-form-item {
      margin-bottom: 14px;
      &.noWidth {
        .el-form-item__content {
          display: none;
        }
      }
      &.isErr {
        color: red;
      }
      &.contentReadonly {
        .el-form-item__content {
          background:#F5F7FA
        }
      }
      //height: 26px;
    }

    .el-form-item__label,
    .el-form-item__content {
      color: @fc6;
      /*font-weight: 600;*/
      font-size: @fz4;
    }

    .el-form-item__label {
      height: 26px;
      line-height: 26px;
    }

    .el-form-item__content {
      line-height: 26px;
      .el-input__icon {
        line-height: 26px;
      }
    }

    .el-input__inner {
      height: 24px;
      line-height: 24px;
    }
    .el-cascader--mini {
      width: 100%;
      line-height: 26px;
    }
    .el-icon-arrow-down {
      height: 23px;
    }
    .sel2ipt > .el-input__inner {
      width: 70px;
      height: 26px;
    }

    .el-input-group__append {
      padding: 0;
      width: 100%;
    }
    .address-wrapper {
      display: flex;
      .detail-address-input {
        margin-left: 4px;
        .el-input__inner {
          border-color: #dcdfe6;
        }
      }
      & + .el-form-item__error {
        position: absolute;
        left: 41%;
        top: 3px;
      }
    }
  }

  .right-btn-box {
    text-align: left;
    display: flex;
    align-items: center;

    & > div {
      display: inline-block;
    }

    .t-r-btn,
    & > .el-button,
    & > div > .el-button,
    & > div > div > .el-button,
    span > .el-button {
      margin-left: 0;
      color: @linkColor;
      border: none;
      background: #fff;
      padding: 5px;
      &:hover,
      &:focus {
        color: @icColor;
      }
    }
  }

  .change {
    text-align: right;

    .t-r-btn {
      color: @linkColor;
      &:hover,
      &:focus {
        color: @icColor;
      }
    }

    & > .el-button,
    & > div > .el-button,
    & > div > div > .el-button,
    span > .el-button {
      margin-left: 0;
      color: @linkColor;
      margin-bottom: 5px;
      &:hover,
      &:focus {
        color: @icColor;
      }
    }

    & > div {
      display: inline-block;
    }
  }

  .footer-btn-box {
    padding: 15px;
    text-align: center;
  }

  .footer-btn-box.right-bottom {
    padding: 15px;
    text-align: right;
    margin-right: 20px;
  }
  .pointer {
    cursor: pointer;
  }
  .baseinfo-select {
    position: relative;
    .select-link {
      position: absolute;
      top: 1px;
      left: 15px;
      cursor: pointer;
      color: @linkColor;
      background: #fff;
      text-decoration: underline;
      max-width: 89%;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
}

.check-all-wrapper {
  padding: 0 20px;
  height: 28px;
  line-height: 28px;
}

div.btn-box {
  display: inline-block;
  text-align: center;
  width: 100%;

  & > div {
    width: 100%;
  }
  & > .el-button,
  & > div > .el-button {
    margin-left: 0;
    margin-bottom: 5px;
    width: 100%;
    border: none;
    border-radius: 0;
    background: #fff;
    border-bottom: 1px solid @lc;
  }
}
//datarange 至
/deep/ .el-range-editor--mini .el-range-separator {
  line-height: 15px;
}
//多选，要撑开盒子  让这个元素高度失效
.selectMultiple {
  // display: inline;
}
//theme-dark
// 黑色系调整
.base-info-theme-dark {
  background: #000;
  color: #fff;
  .el-col {
    .u-label,
    .u-val {
      background: #000;
      color: #fff;
    }
  }
}
.edit-readonly {
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;
  text-align: left;
}

.el-select-dropdown__list {
  // max-width: 500px;
}
</style>
<style lang="less" scoped>
.phoneSelf{
  display: flex;
  align-items: center;
}
.el-button--primary.is-disabled {
  color: #fff;
  background-color: rgb(245, 171, 148);
  border-color: rgb(245, 171, 148);
}
.isAddRead {
  text-align: left;
}
.uom {
  display: block;
  background: #ccc;
  color: #fff;
  width: 50px;
  height: 24px;
  margin-right: -5px;
  margin-top: 2px;
  border-radius: 0 4px 4px 0;
  line-height: 20px;
}
.el-col__self {
  position: relative;
  white-space: nowrap;
  & > div {
    display: inline-flex;
    max-width: 100%;
    // max-width: calc(100% - 20px);
    .u-val {
      flex: 1;
    }
    template{
      display: inline-block;
    }
  }
}
/deep/ .el-icon-copy-document {
  color: @fc9;
  position: relative;
  top: 1px;
  cursor: pointer;
  font-size: 14px;
}
.widthControl {
  width: 100%;
  &.hasCopy {
    width: auto;
    max-width: calc(100% - 20px);
  }
}
/deep/ .el-select__caret.el-input__icon.el-icon-arrow-up {
  height: 22px;
  line-height: 22px;
}
/deep/ .el-radio-group {
  &.align-left {
    width: 100%;
    text-align: left;
  }
}
</style>
<style lang="less">
.error-deal .el-col .el-form-item__error {
  background: #fff;
  text-align: right;
  padding-right: 5px;
  border-radius: 0 4px 4px 0;
  transition: none;
  cursor: pointer;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  white-space: nowrap;
  top: 3px;
  height: 20px; //超出输入框，减小高度
  width: auto;
  right: 2px;
  display: inline-block;
  line-height: 22px;
  position: absolute;
  left: 2px;
}
.error-deal {
  .el-input__prefix,
  .el-input__suffix {
    // height: calc(100% - 2px);
  }
  .el-col {
    line-height: 26px;
  }
  .el-col .el-input__inner {
    height: 24px;
    line-height: 24px;
  }
  .el-col .u-label {
    margin-bottom: 4px;
  }
  .el-col .el-form-item {
    margin-bottom: 0;
    height: 26px;
    margin-bottom: 4px;
    &.heightAuto {
      height: auto;
    }
    &.contact_info {
      margin-bottom: 0;
    }
  }
  &.create-dialog .el-col {
    margin-bottom: 14px;
  }
  .el-col.custom-style {
    padding-left: 4px !important;
    padding-right: 4px !important;
  }
  .el-form-item__content {
    overflow: hidden;
    text-align: right;
  }
  .el-col.value-position-left .el-form-item__content {
    text-align: left;
  }
  .el-col.height-initial .el-form-item {
    height: initial;
    .el-form-item__label {
      display: block;
    }
    .el-form-item__content {
      margin-left: 0 !important;
    }
  }
  .el-col {
    .el-input,
    .el-select,
    .el-textarea,
    .baseinfo-select,
    .el-autocomplete,
    .el-cascader,
    .category-component,
    .el-radio-group,
    .edit-readonly,
    .address-wrapper
    {

      &:focus-within + .el-form-item__error {
        animation: none;
        transform: translateX(102%);
      }
      & + .el-form-item__error {
        animation: baseErrorMove 2s linear both;
      }
      & + .el-form-item__error.removeAni {
        animation: none;
        transform: translateX(102%);
      }
    }
    .phoneSelfItem{
      &:focus-within .phoneSelf + .el-form-item__error {
        animation: none;
        transform: translateX(102%);
      }
      .phoneSelf  + .el-form-item__error {
        animation: baseErrorMove 2s linear both;
      }
    }
    .address-wrapper {
      &:focus-within + .el-form-item__error {
        z-index: -1;
      }
      & + .el-form-item__error.removeAni {
        z-index: -1;
      }
    }
  }
}

@keyframes baseErrorMove {
  0% {
    z-index: -1;
    transform: translateX(102%);
  }
  5% {
    z-index: 10;
    transform: translateX(0);
  }
  99% {
    z-index: 10;
    transform: translateX(0);
  }
  100% {
    transform: translateX(102%);
    z-index: -1;
  }
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
input[type='number'] {
  -moz-appearance: textfield;
}
</style>
